import { AccountSettingsItems } from "@components/mainInterface/UserDropdown/AccountSettingsItems";
import { ReferralDrawerTrigger } from "@components/mainInterface/UserDropdown/ReferralDrawerTrigger";

export const PersonalViewUserDropdownItems: React.FC = () => (
    <>
        <AccountSettingsItems />
        <ReferralDrawerTrigger />
    </>
);
